import { type FunctionComponent } from 'react';

// components
import { PriceAmount } from './PriceAmount.tsx';

type Props = {
    price?: number;
    originalPrice?: number;
    percentageOff?: number;
    currency: string;
    quantityDisplay: string | null;
    hasPrivateOffer?: boolean;
    displayVatLabel?: boolean;
    vatLabelClassName?: string;
    priceBookName: string | null;
    showCompactedPrice?: boolean;
    showNetRetailPrice?: boolean;
};

/**
 * Price Components for an item with a net price
 *  (Net or Net & Retail)
 */
export const NetItemPrices: FunctionComponent<Props> = ({
    price,
    originalPrice,
    currency,
    percentageOff,
    quantityDisplay,
    hasPrivateOffer,
    displayVatLabel,
    vatLabelClassName,
    priceBookName,
    showCompactedPrice = false,
    showNetRetailPrice = true,
}) => (
    <>
        {/* NET PRICE */}
        {!!price && (
            <PriceAmount
                type="NET"
                showLabel={!showCompactedPrice}
                amount={price}
                currency={currency}
                quantityDisplay={quantityDisplay}
                hasPrivateOffer={hasPrivateOffer}
                displayVatLabel={displayVatLabel}
                vatLabelClassName={vatLabelClassName}
                priceBookName={priceBookName}
            />
        )}
        {/* RETAIL PRICE */}
        {showNetRetailPrice && !!originalPrice && !hasPrivateOffer && !showCompactedPrice && (
            <PriceAmount
                hasNetPrice
                discount={percentageOff}
                currency={currency}
                amount={originalPrice}
                quantityDisplay={quantityDisplay}
                hasPrivateOffer={hasPrivateOffer}
                priceBookName={priceBookName}
            />
        )}
    </>
);
